/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e({when:e,delay:r,delayChildren:t,staggerChildren:n,staggerDirection:a,repeat:l,repeatType:d,repeatDelay:i,from:p,elapsed:g,...o}){return!!Object.keys(o).length}function r(e,r){return e[r]||e.default||e}export{r as getValueTransition,e as isTransitionDefined};
//# sourceMappingURL=transitions.js.map
